import React from 'react'

function readLang() {
  try {
    const saved = localStorage.getItem('ui.lang')
    if (saved && String(saved).toLowerCase().startsWith('en')) return 'en'
    if (saved) return 'zh'
  } catch {}
  try {
    const nav = String(navigator.language || '').toLowerCase()
    if (nav.startsWith('en')) return 'en'
  } catch {}
  return 'zh'
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    try {
      // Best-effort: surface for debugging in console.
      console.error('Console crashed:', error, info)
      window.__CHAMII_CONSOLE_LAST_ERROR__ = { error, info }
    } catch {
      // ignore
    }
  }

  render() {
    if (!this.state.error) return this.props.children

    const message = this.state.error?.message ? String(this.state.error.message) : String(this.state.error)
    const stack = this.state.error?.stack ? String(this.state.error.stack) : ''
    const lang = readLang()
    const title = lang === 'en' ? 'Console failed to start' : '控制台启动失败'

    return (
      <div className="min-h-[60vh] p-6">
        <div className="max-w-3xl mx-auto bg-white dark:bg-slate-950 rounded-3xl border-2 border-rose-100 dark:border-slate-800 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)] p-6">
          <div className="text-slate-900 dark:text-slate-100 text-lg font-extrabold">{title}</div>
          <div className="mt-2 text-slate-700 dark:text-slate-200 text-sm font-bold">{message}</div>
          {stack ? (
            <pre className="mt-4 text-[12px] leading-relaxed text-slate-600 dark:text-slate-200 whitespace-pre-wrap bg-slate-50 dark:bg-slate-900 border-2 border-slate-100 dark:border-slate-800 rounded-2xl p-4 overflow-auto">
              {stack}
            </pre>
          ) : null}
        </div>
      </div>
    )
  }
}
